import Option from '@/components/form/types/Option.ts';

export const MONTH_LABELS = [
  'Styczeń',
  'Luty',
  'Marzec',
  'Kwiecień',
  'Maj',
  'Czerwiec',
  'Lipiec',
  'Sierpień',
  'Wrzesień',
  'Październik',
  'Listopad',
  'Grudzień',
] as const;

/** Genitive (dopełniacz) forms used in deadline / period sentences. */
export const MONTH_GENITIVE = [
  'stycznia',
  'lutego',
  'marca',
  'kwietnia',
  'maja',
  'czerwca',
  'lipca',
  'sierpnia',
  'września',
  'października',
  'listopada',
  'grudnia',
] as const;

/** @param month 1-based month number. */
export const getMonthLabel = (month: number): string =>
  MONTH_LABELS[month - 1] ?? '';

/** @param month 1-based month number. */
export const getMonthGenitive = (month: number): string =>
  MONTH_GENITIVE[month - 1] ?? '';

/** Options for the month `SingleSelectInput` (values are strings: "1".."12"). */
export const MONTH_OPTIONS: Option[] = MONTH_LABELS.map((label, index) => ({
  label,
  value: String(index + 1),
}));

export interface YearMonth {
  year: number;
  month: number;
}

/**
 * Previous completed month relative to now — the period a user typically files
 * (June's declaration is filed in July). Used as the generate-dialog default.
 */
export const getPreviousMonth = (now: Date = new Date()): YearMonth => {
  const date = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return { year: date.getFullYear(), month: date.getMonth() + 1 };
};

/** Filing deadline for a given period: the 21st of the following month. */
export const getFilingDeadline = ({ year, month }: YearMonth): Date =>
  new Date(year, month, 21);
